module.exports = __webpack_public_path__ + "static/media/case-study-bg.d15d1001.png";